import React from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import BarChart from "../charts/BarChart";
import ChartFrame from "../charts/ChartFrame";
import ResponsiveChart from "../charts/ResponsiveChart";
import { slotColor } from "../charts/chartTheme";
import { formatCompact, formatCount } from "../charts/format";

// Barras de uma so serie dentro da moldura, com a tabela. Uma serie so: o titulo diz o que e, e nao
// ha legenda. Os rotulos do eixo saltam categorias quando nao cabem (cerca de 48 px cada). Uma barra
// a null (uma hora que ainda nao chegou, no Quando de um dia) fica sem barra e com a celula vazia.
const BarsFigure = ({ title, note, lead, info, bars, band, height = 200, downloadName }) => {
  const { translate, language } = useLanguage();
  const table = {
    columns: [
      { key: "label", label: translate("analyticsCategory") },
      { key: "value", label: translate("analyticsCount"), numeric: true, format: (value) => (value === null ? "" : formatCount(value, language)) },
    ],
    rows: bars,
  };
  return (
    <ChartFrame title={title} note={note} lead={lead} info={info} table={table} downloadName={downloadName} empty={!bars.some((bar) => bar.value > 0)}>
      <ResponsiveChart height={height}>
        {(width) => (
          <BarChart
            data={bars}
            width={width}
            height={height}
            colorOf={() => slotColor(1)}
            label={title}
            band={band}
            formatValue={(value) => formatCount(value, language)}
            formatTick={(value) => formatCompact(value, language)}
            tickEvery={Math.max(1, Math.ceil(bars.length / Math.max(1, Math.floor(width / 48))))}
          />
        )}
      </ResponsiveChart>
    </ChartFrame>
  );
};

export default BarsFigure;
